import { ReleaseStepType } from '../types';
import { StringKeyedDictionary } from '../typescriptHelpers';
import * as AnalyticEvents from '../utils/analytics';

export const TRACK_ORG_ROUTE_EVENT = 'TRACK_ORG_ROUTE_EVENT';
export const TRACK_APP_ROUTE_EVENT = 'TRACK_APP_ROUTE_EVENT';
export const TRACK_RELEASE_ROUTE_EVENT = 'TRACK_RELEASE_ROUTE_EVENT';
export const TRACK_RELEASE_STEP_VIEW_EVENT = 'TRACK_RELEASE_STEP_VIEW_EVENT';
export const TRACK_USER_EVENT = 'TRACK_USER_EVENT';
export const TRACK_ONBOARDING_EVENT = 'TRACK_ONBOARDING_EVENT';
export const TRACK_QUICK_START_EVENT = 'TRACK_QUICK_START_EVENT';
export const TRACK_BUILD_DISTRO_EVENT = 'TRACK_BUILD_DISTRO_EVENT';

export interface TrackOrgRouteViewEventActionData {
    orgId: string;
    eventName: AnalyticEvents.Event;
    viewType?: string;
    page?: string;
}

export interface TrackAppRouteViewEventActionData extends TrackOrgRouteViewEventActionData {
    appId: string;
}

export interface TrackBuildDistroActionData {
    orgId: string;
    appId: string;
    bucketId?: string;

    extraProperties?: StringKeyedDictionary<any>;
}

export interface TrackReleaseActionData {
    orgId: string;
    appId: string;
    releaseId: string;
}

export interface TrackReleaseStepEventActionData extends TrackReleaseActionData {
    releaseStepType: ReleaseStepType;
}

export interface TrackBuildDistroEventActionData extends TrackBuildDistroActionData {
    eventName: AnalyticEvents.Event;
}

export interface TrackReleaseEventActionData extends TrackReleaseActionData {
    eventName: AnalyticEvents.Event;
    context?: AnalyticEvents.Context;
    chartName?: string;
    stepArchetype?: ReleaseStepType;
}

export interface TrackOnboardingEventActionData extends TrackAppRouteViewEventActionData {
    taskType: string;
}

export interface TrackQuickStartEventActionData extends TrackOrgRouteViewEventActionData {
    appId?: string;
    extraData: Record<string, unknown>;
}

// Actions

export interface TrackOrgRouteEventAction {
    type: typeof TRACK_ORG_ROUTE_EVENT;
    payload: TrackOrgRouteViewEventActionData;
}

export interface TrackAppRouteEventAction {
    type: typeof TRACK_APP_ROUTE_EVENT;
    payload: TrackAppRouteViewEventActionData;
}

export interface TrackReleaseRouteEventAction {
    type: typeof TRACK_RELEASE_ROUTE_EVENT;
    payload: TrackReleaseEventActionData;
}

export interface TrackReleaseStepViewEventAction {
    type: typeof TRACK_RELEASE_STEP_VIEW_EVENT;
    payload: TrackReleaseStepEventActionData;
}

export interface TrackBuildDistroViewEventAction {
    type: typeof TRACK_BUILD_DISTRO_EVENT;
    payload: TrackBuildDistroEventActionData;
}

export interface TrackUserEventAction {
    type: typeof TRACK_USER_EVENT;
    payload: TrackAppRouteViewEventActionData;
}

export interface TrackOnboardingEventAction {
    type: typeof TRACK_ONBOARDING_EVENT;
    payload: TrackOnboardingEventActionData;
}

export interface TrackQuickStartEventAction {
    type: typeof TRACK_QUICK_START_EVENT;
    payload: TrackQuickStartEventActionData;
}

export const trackBuildDistroViewEvent: (
    payload: TrackBuildDistroEventActionData,
) => TrackBuildDistroViewEventAction = (payload) => {
    return {
        type: TRACK_BUILD_DISTRO_EVENT,
        payload,
    };
};

export const trackReleaseRouteEvent: (payload: TrackReleaseEventActionData) => TrackReleaseRouteEventAction = (
    payload,
) => {
    return {
        type: TRACK_RELEASE_ROUTE_EVENT,
        payload,
    };
};

export const trackReleaseStepViewEvent: (
    payload: TrackReleaseStepEventActionData,
) => TrackReleaseStepViewEventAction = (payload) => {
    return {
        type: TRACK_RELEASE_STEP_VIEW_EVENT,
        payload,
    };
};

export const trackOrgRouteEvent: (payload: TrackOrgRouteViewEventActionData) => TrackOrgRouteEventAction = (
    payload,
) => {
    return {
        type: TRACK_ORG_ROUTE_EVENT,
        payload,
    };
};

export const trackAppRouteEvent: (payload: TrackAppRouteViewEventActionData) => TrackAppRouteEventAction = (
    payload,
) => {
    return {
        type: TRACK_APP_ROUTE_EVENT,
        payload,
    };
};

export const trackUserEvent: (payload: TrackAppRouteViewEventActionData) => TrackUserEventAction = (payload) => {
    return {
        type: TRACK_USER_EVENT,
        payload,
    };
};

export const trackOnboardingEvent: (payload: TrackOnboardingEventActionData) => TrackOnboardingEventAction = (
    payload,
) => {
    return {
        type: TRACK_ONBOARDING_EVENT,
        payload,
    };
};

export const trackQuickStartCIEvent: (payload: TrackQuickStartEventActionData) => TrackQuickStartEventAction = (
    payload,
) => {
    return {
        type: TRACK_QUICK_START_EVENT,
        payload,
    };
};
